const pageNameBackupKey = "otaPushFirmwareBackupModal";

export const otaPushFirmwareBackupModalEn = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Close push backup modal",
    title: "Push Backup",
    backupSectionTitle: "The backup",
    uploadedAtLabel: "uploaded",
    machineSectionTitle: "will be pushed to the machine",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle: "The backup package contains the following folders:",
    targetPathLabel: "Target path on the machine:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Username:",
    usernamePlaceholder: "Enter username",
    passwordLabel: "Password:",
    passwordPlaceholder: "Enter password",
    privateKeyFileForAuthLabel: "Private key file for authentication:",
    privateKeyPasswordLabel: "Password for the Private Key file:",
    privateKeyPasswordPlaceholder: "Enter private key file password",
    helperText:
      "Send the backup package for verification and ask the Operator for approval.",
    cancelButtonText: "Cancel",
    askForApprovalButtonText: "Ask for Approval",
    pleaseFixFields: "Please fix the following fields:",
    failedToCreateInstallationProcess: "Failed to create installation process",
    installationProcessAlreadyExists:
      "An installation process is already active for this machine.",
    targetPathLabelWithoutColon: "Target path on the machine",
    usernameLabelWithoutColon: "Username",
    privateKeyFileForAuthLabelWithoutColon:
      "Private key file for authentication",
    passwordOrPrivateKeyRequired:
      "Either Password or Private key file for authentication",
  },
};

export const otaPushFirmwareBackupModalPtBr = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Fechar modal de envio de backup",
    title: "Enviar backup",
    backupSectionTitle: "O backup",
    uploadedAtLabel: "enviado em",
    machineSectionTitle: "será enviado para a máquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle: "O pacote de backup contém as seguintes pastas:",
    targetPathLabel: "Caminho de destino na máquina:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Nome de usuário:",
    usernamePlaceholder: "Digite o nome de usuário",
    passwordLabel: "Senha:",
    passwordPlaceholder: "Digite a senha",
    privateKeyFileForAuthLabel: "Arquivo de chave privada para autenticação:",
    privateKeyPasswordLabel: "Senha para o arquivo de chave privada:",
    privateKeyPasswordPlaceholder: "Digite a senha da chave privada",
    helperText:
      "Envie o pacote de backup para verificação e solicite aprovação do Operador.",
    cancelButtonText: "Cancelar",
    askForApprovalButtonText: "Solicitar aprobación",
    pleaseFixFields: "Por favor, corrija los siguientes campos:",
    failedToCreateInstallationProcess: "Falha ao criar processo de instalação",
    installationProcessAlreadyExists:
      "Um processo de instalação já está ativo para esta máquina.",
    targetPathLabelWithoutColon: "Caminho de destino na máquina",
    usernameLabelWithoutColon: "Nome de usuário",
    privateKeyFileForAuthLabelWithoutColon:
      "Arquivo de chave privada para autenticação",
    passwordOrPrivateKeyRequired:
      "Informe a senha ou o arquivo de chave privada",
  },
};

export const otaPushFirmwareBackupModalDe = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Modal zum Backup-Push schließen",
    title: "Backup übertragen",
    backupSectionTitle: "Die Backup",
    uploadedAtLabel: "hochgeladen",
    machineSectionTitle: "wird auf die Maschine übertragen",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle: "Das Backup-Paket enthält folgende Ordner:",
    targetPathLabel: "Zielpfad auf der Maschine:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Benutzername:",
    usernamePlaceholder: "Benutzernamen eingeben",
    passwordLabel: "Passwort:",
    passwordPlaceholder: "Passwort eingeben",
    privateKeyFileForAuthLabel: "Private Schlüsseldatei zur Authentifizierung:",
    privateKeyPasswordLabel: "Passwort für die private Schlüsseldatei:",
    privateKeyPasswordPlaceholder:
      "Passwort für private Schlüsseldatei eingeben",
    helperText:
      "Senden Sie das Backup-Paket zur Verifizierung und bitten Sie den Operator um Freigabe.",
    cancelButtonText: "Abbrechen",
    askForApprovalButtonText: "Freigabe anfragen",
    pleaseFixFields: "Bitte beheben Sie die folgenden Felder:",
    failedToCreateInstallationProcess:
      "Installationsprozess konnte nicht erstellt werden",
    installationProcessAlreadyExists:
      "Für diese Maschine ist bereits ein Installationsprozess aktiv.",
    targetPathLabelWithoutColon: "Zielpfad auf der Maschine",
    usernameLabelWithoutColon: "Benutzername",
    privateKeyFileForAuthLabelWithoutColon:
      "Private Schlüsseldatei zur Authentifizierung",
    passwordOrPrivateKeyRequired:
      "Passwort oder private Schlüsseldatei ist erforderlich",
  },
};

export const otaPushFirmwareBackupModalZhHans = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "关闭备份推送弹窗",
    title: "推送备份",
    backupSectionTitle: "该备份",
    uploadedAtLabel: "上传于",
    machineSectionTitle: "将被推送到设备",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle: "备份包包含以下文件夹：",
    targetPathLabel: "设备上的目标路径：",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "用户名：",
    usernamePlaceholder: "输入用户名",
    passwordLabel: "密码：",
    passwordPlaceholder: "输入密码",
    privateKeyFileForAuthLabel: "用于身份验证的私钥文件：",
    privateKeyPasswordLabel: "私钥文件密码：",
    privateKeyPasswordPlaceholder: "输入私钥文件密码",
    helperText: "发送备份包进行验证，并请求操作员批准。",
    cancelButtonText: "取消",
    askForApprovalButtonText: "请求批准",
    pleaseFixFields: "请修复以下字段：",
    failedToCreateInstallationProcess: "创建安装流程失败",
    installationProcessAlreadyExists: "该设备已有一个正在进行的安装流程。",
    targetPathLabelWithoutColon: "设备上的目标路径",
    usernameLabelWithoutColon: "用户名",
    privateKeyFileForAuthLabelWithoutColon: "用于身份验证的私钥文件",
    passwordOrPrivateKeyRequired: "密码或私钥文件至少填写一项",
  },
};

export const otaPushFirmwareBackupModalIt = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Chiudi la finestra di invio backup",
    title: "Invia backup",
    backupSectionTitle: "Il backup",
    uploadedAtLabel: "caricato il",
    machineSectionTitle: "verra inviato alla macchina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle: "Il pacchetto backup contiene le seguenti cartelle:",
    targetPathLabel: "Percorso di destinazione sulla macchina:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Nome utente:",
    usernamePlaceholder: "Inserisci nome utente",
    passwordLabel: "Password:",
    passwordPlaceholder: "Inserisci password",
    privateKeyFileForAuthLabel: "File chiave privata per autenticazione:",
    privateKeyPasswordLabel: "Password per il file della chiave privata:",
    privateKeyPasswordPlaceholder:
      "Inserisci la password del file della chiave privata",
    helperText:
      "Invia il pacchetto backup per la verifica e chiedi l'approvazione dell'Operatore.",
    cancelButtonText: "Annulla",
    askForApprovalButtonText: "Richiedi approvazione",
    pleaseFixFields: "Si prega di correggere i seguenti campi:",
    failedToCreateInstallationProcess:
      "Impossibile creare il processo di installazione",
    installationProcessAlreadyExists:
      "Per questa macchina e già attivo un processo di installazione.",
    targetPathLabelWithoutColon: "Percorso di destinazione sulla macchina",
    usernameLabelWithoutColon: "Nome utente",
    privateKeyFileForAuthLabelWithoutColon:
      "File chiave privata per autenticazione",
    passwordOrPrivateKeyRequired:
      "Inserisci la password o carica il file di chiave privata",
  },
};

export const otaPushFirmwareBackupModalEs = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Cerrar modal de envio de backup",
    title: "Enviar backup",
    backupSectionTitle: "El backup",
    uploadedAtLabel: "subido el",
    machineSectionTitle: "se enviara a la maquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle:
      "El paquete de backup contiene las siguientes carpetas:",
    targetPathLabel: "Ruta de destino en la maquina:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Nombre de usuario:",
    usernamePlaceholder: "Introduce el nombre de usuario",
    passwordLabel: "Contraseña:",
    passwordPlaceholder: "Introduce la contraseña",
    privateKeyFileForAuthLabel: "Archivo de clave privada para autenticacion:",
    privateKeyPasswordLabel: "Contraseña para el archivo de clave privada:",
    privateKeyPasswordPlaceholder:
      "Introduce la contraseña del archivo de clave privada",
    helperText:
      "Envia el paquete de backup para verificacion y solicita la aprobacion del Operador.",
    cancelButtonText: "Cancelar",
    askForApprovalButtonText: "Solicitar aprobacion",
    pleaseFixFields: "Por favor, corrija los siguientes campos:",
    failedToCreateInstallationProcess:
      "No se pudo crear el proceso de instalacion",
    installationProcessAlreadyExists:
      "Ya hay un proceso de instalacion activo para esta maquina.",
    targetPathLabelWithoutColon: "Ruta de destino en la maquina",
    usernameLabelWithoutColon: "Nombre de usuario",
    privateKeyFileForAuthLabelWithoutColon:
      "Archivo de clave privada para autenticacion",
    passwordOrPrivateKeyRequired:
      "Debe proporcionar contraseña o archivo de clave privada",
  },
};

export const otaPushFirmwareBackupModalNl = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Backup-pushvenster sluiten",
    title: "Backup pushen",
    backupSectionTitle: "De backup",
    uploadedAtLabel: "geupload op",
    machineSectionTitle: "wordt naar de machine gepusht",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    foldersSectionTitle: "Het backuppakket bevat de volgende mappen:",
    targetPathLabel: "Doelpad op de machine:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Gebruikersnaam:",
    usernamePlaceholder: "Voer gebruikersnaam in",
    passwordLabel: "Wachtwoord:",
    passwordPlaceholder: "Voer wachtwoord in",
    privateKeyFileForAuthLabel: "Privatesleutelbestand voor authenticatie:",
    privateKeyPasswordLabel: "Wachtwoord voor het privatesleutelbestand:",
    privateKeyPasswordPlaceholder:
      "Voer wachtwoord voor privatesleutelbestand in",
    helperText:
      "Stuur het backuppakket ter verificatie en vraag de Operator om goedkeuring.",
    cancelButtonText: "Annuleren",
    askForApprovalButtonText: "Goedkeuring vragen",
    pleaseFixFields: "Los de volgende velden op:",
    failedToCreateInstallationProcess: "Installatieproces maken is mislukt",
    installationProcessAlreadyExists:
      "Er is al een installatieproces actief voor deze machine.",
    targetPathLabelWithoutColon: "Doelpad op de machine",
    usernameLabelWithoutColon: "Gebruikersnaam",
    privateKeyFileForAuthLabelWithoutColon:
      "Privatesleutelbestand voor authenticatie",
    passwordOrPrivateKeyRequired:
      "Voer wachtwoord in of upload een privatesleutelbestand",
  },
};

export const otaPushFirmwareBackupModalTr = {
  [pageNameBackupKey]: {
    closePushBackupModalAriaLabel: "Push yedekleme modunu kapat",
    title: "Yedeklemeyi itin",
    backupSectionTitle: "Yedekleme",
    uploadedAtLabel: "yüklendi",
    machineSectionTitle: "makineye itilecek",
    machineIdLabel: "İD",
    machineIpLabel: "IP",
    foldersSectionTitle: "Yedekleme paketi aşağıdaki klasörleri içerir:",
    targetPathLabel: "Makinedeki hedef yol:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Kullanıcı adı:",
    usernamePlaceholder: "Kullanıcı adını girin",
    passwordLabel: "Şifre:",
    passwordPlaceholder: "Şifreyi girin",
    privateKeyFileForAuthLabel: "Kimlik doğrulama için özel anahtar dosyası:",
    privateKeyPasswordLabel: "Özel Anahtar dosyasının şifresi:",
    privateKeyPasswordPlaceholder: "Özel anahtar dosyası şifresini girin",
    helperText:
      "Yedekleme paketini doğrulama için gönderin ve Operatörden onay isteyin.",
    cancelButtonText: "İptal etmek",
    askForApprovalButtonText: "Onay İste",
    pleaseFixFields: "Lütfen aşağıdaki alanları düzeltin:",
    failedToCreateInstallationProcess: "Yükleme işlemi oluşturulamadı",
    installationProcessAlreadyExists:
      "Bu makine için bir yükleme işlemi zaten etkin.",
    targetPathLabelWithoutColon: "Makinedeki hedef yol",
    usernameLabelWithoutColon: "Kullanıcı adı",
    privateKeyFileForAuthLabelWithoutColon:
      "Kimlik doğrulama için özel anahtar dosyası",
    passwordOrPrivateKeyRequired:
      "Kimlik doğrulama için Şifre veya Özel anahtar dosyası",
  },
};
